<template>
  <div class="block">
    <el-form class="form" ref="ruleForm" label-width="120px" :model="form" :rules="rules">
      <el-form-item label="牌局类型：" prop="roomPath">
        <el-input v-model="form.roomPath" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="牌局ID：" prop="roomId">
        <el-input v-model="form.roomId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="用户ID：" prop="userShowId">
        <el-input v-model="form.userShowId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入">
          <el-select style="width: 100px" v-model="form.countryCode" slot="prepend">
            <el-option
              v-for="item of mobileCountryCodeOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="谷歌验证码：" prop="code">
        <el-input v-model="form.code" placeholder="请输入"> </el-input>
      </el-form-item>
      <div class="footer">
        <el-button type="primary" @click="submitForm('ruleForm')">设置</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { mobileCountryCodeOptions } from 'mixins';

export default {
  mixins: [mobileCountryCodeOptions],
  data() {
    return {
      form: {
        roomPath: '',
        roomId: '',
        userShowId: '',
        mobile: '',
        countryCode: '86',
        code: '',
      },
      rules: {
        roomPath: [{ required: true, message: '请输入牌局类型', trigger: 'blur' }],
        roomId: [{ required: true, message: '请输入牌局ID', trigger: 'blur' }],
        userShowId: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    };
  },
  methods: {
    ...mapActions('other', ['sendCode']),
    ...mapActions('at', ['mtDispatch']),

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.mtDispatch(this.form).then(() => {
            this.$message.success('设置成功');
            this.$refs[formName].resetFields();
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.block {
  position: relative;
  min-height: 400px;
}
.form {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  @media (min-height: 590px) {
    top: 15%;
  }
  :global(.el-select) {
    width: 100%;
  }
}

.footer {
  padding: 15px 0 0 100px;
  text-align: center;
  :global(.el-button) {
    width: 150px;
  }
}
</style>
